import React from "react";
import { Button } from "../ui/button";
import { useToast } from "../ui/use-toast";
import {
  isGuessCorrect,
  isGuessRepeated,
  shuffleGameData,
} from "../../lib/game-helpers";

import { GameStatusContext } from "../../providers/GameStatusProvider";
import { PuzzleDataContext } from "../../providers/PuzzleDataProvider";

function GameControlButtonsPanel({
  shuffledRows,
  setShuffledRows,
  setGridShake,
}) {
  const {
    isGameOver,
    guessCandidate,
    setGuessCandidate,
    submittedGuesses,
    setSubmittedGuesses,
    solvedGameData,
    setSolvedGameData,
  } = React.useContext(GameStatusContext);
  const { gameData, categorySize } = React.useContext(PuzzleDataContext);
  const { toast } = useToast();

  function deselectAll() {
    setGuessCandidate([]);
  }

  function submitCandidateGuess() {
    // check that its a valid guess by size
    if (guessCandidate.length !== categorySize) {
      return;
    }
    // check that the guess hasnt already been submitted previously
    if (isGuessRepeated({ submittedGuesses, guessCandidate })) {
      toast({
        label: "Notification",
        title: "Repeated Guess",
        description: "You previously made this guess!",
      });

      return;
    }
    // add guess to state
    setSubmittedGuesses([...submittedGuesses, guessCandidate]);
    // check if the guess is correct
    const {
      isCorrect,
      correctWords,
      correctCategory,
      correctDifficulty,
      isGuessOneAway,
    } = isGuessCorrect({
      guessCandidate,
      gameData,
    });

    // if the guess is correct:
    // set it as solved in game data
    if (isCorrect) {
      setSolvedGameData([
        ...solvedGameData,
        {
          category: correctCategory,
          words: correctWords,
          difficulty: correctDifficulty,
        },
      ]);
      setGuessCandidate([]);
    } else {
      // Shake the grid to give feedback that they were wrong
      setGridShake(true);
      if (isGuessOneAway) {
        toast({
          label: "Notification",
          title: "Close Guess",
          description:
            "You were one guess away from correctly guessing a category!",
        });
      }
    }
  }

  const pillBase =
    "h-10 px-4 rounded-full border border-black bg-white text-black text-sm font-semibold whitespace-nowrap leading-none hover:bg-neutral-100 disabled:opacity-50";
  const pillSubmit =
    "h-10 px-4 rounded-full border border-black bg-black text-white text-sm font-semibold whitespace-nowrap leading-none hover:bg-neutral-800 disabled:bg-white disabled:text-black disabled:opacity-50";

  return (
    <div className="flex flex-wrap gap-4 justify-center">
      <Button
        disabled={isGameOver}
        className={pillBase}
        onClick={() =>
          setShuffledRows(shuffleGameData({ gameData: shuffledRows }))
        }
      >
        Shuffle
      </Button>
      <Button
        disabled={isGameOver}
        className={pillBase}
        onClick={deselectAll}
      >
        Deselect all
      </Button>
      <Button
        className={pillSubmit}
        onClick={submitCandidateGuess}
        disabled={isGameOver || guessCandidate.length !== categorySize}
      >
        Submit
      </Button>
    </div>
  );
}

export default GameControlButtonsPanel;
